// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"fc2640c3","242":"a2d1b0da","392":"26f97302","407":"8c50ea46","473":"8d8d55d2","551":"f68432ac","576":"9029fc65","688":"0d202f19","715":"21592df0","784":"0a1caedd","814":"390c025d","941":"dcb29448","944":"4a2db49d"}[chunkId] + ".chunk.js";
};